export default __webpack_public_path__ + "static/media/3.5c1d3c56.png";